import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import NcFileVersions from '@components/ncFileVersions';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';

interface NCFileDetailsNCFileVersionsProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const NCFileDetailsNCFileVersionsComponent: FC<NCFileDetailsNCFileVersionsProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  ncFileData,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getNCFileById,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <NcFileVersions ncFile={ncFileData.data} loaded={ncFileData.wasLoaded} enableResponsiveTwoColumnView={false} />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFileVersions = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsNCFileVersionsComponent);

export { NCFileDetailsNCFileVersions };
